import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserDetail } from '../../models/user-detail';
import { HttpClient } from '@angular/common/http';
import { StoreService } from '../store-service/store.service';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  constructor(
    private storeService: StoreService,
    private authService: MsalService,
  ) {}

  // get user(): UserDetail {
  //   return this._user.getValue();
  // }

  buildUserImageUrl(lanId?: string): string {
    if (lanId) {
      const cleanedLanId = lanId.replace('\\', '_');
      return `https://mysite.na.xom.com/User%20Photos/Profile%20Pictures/${cleanedLanId}_MThumb.jpg`;
    }
    return '';
  }

  async getUserDetail(): Promise<UserDetail> {
    if (this.storeService.user.isLoaded) {
      return this.storeService.user;
    }

    const account: any = this.authService.instance.getAllAccounts()[0];
    const { oid: id } = account.idTokenClaims;
    const lanId = await this.getLanId(id);

    // Get general detail
    let user: UserDetail = new UserDetail({
      name: account.name,
      email: account.username,
      id,
      lanid: lanId,
      imageURL: this.buildUserImageUrl(lanId),
    });

    // Keep in store
    user.isLoaded = true;
    this.storeService.assignUser(user);

    return user;
  }

  async getLanId(userId?: string): Promise<string> {
    if (!userId) return '';

    try {
      const url = `https://graph.microsoft.com/beta/users?$filter=id eq '${userId}'&$select=id,displayName,mail,extension_d6448b80620845bf89c63bb6933c28da_XOM_FullLANID,jobTitle,givenName,surname`;
      const response: any = await this.http.get(url).toPromise();
      return response.value[0]
        .extension_d6448b80620845bf89c63bb6933c28da_XOM_FullLANID;
    } catch (e) {
      return 'Unknown Lan ID';
    }
  }

  async getAccessToken(): Promise<string> {
    const redirectResponse =
      await this.authService.instance.handleRedirectPromise();
    if (redirectResponse !== null) {
      // Acquire token silent success
      let accessToken = redirectResponse.accessToken;
      return accessToken;
    } else {
      // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
      const account = this.authService.instance.getAllAccounts()[0];

      const accessTokenRequest = {
        scopes: [env.base_api_scope],
        account: account,
      };

      let response =
        await this.authService.instance.acquireTokenSilent(accessTokenRequest);
      return response.accessToken;
    }
  }
}
